import yup from '../../utils/yup';
import createTypedAction from '../createTypedAction';

export const PREFIX = '@@fox/dashboard/';

export const { fetchCheckSheetTasks, FETCH_CHECK_SHEET_TASKS }: any = createTypedAction(
  `${PREFIX}FETCH_CHECK_SHEET_TASKS`,
  ['checkSheetType', yup.string()],
);
export const { fetchCheckSheetTasksSuccess, FETCH_CHECK_SHEET_TASKS_SUCCESS }: any = createTypedAction(
  `${PREFIX}FETCH_CHECK_SHEET_TASKS_SUCCESS`,
  ['tasks', yup.immutable().list()],
  ['checkSheetType', yup.string()],
);
export const { fetchCheckSheetTasksFailed, FETCH_CHECK_SHEET_TASKS_FAILED }: any = createTypedAction(
  `${PREFIX}FETCH_CHECK_SHEET_TASKS_FAILED`,
  ['checkSheetType', yup.string()],
);


export const { saveCheckSheet, SAVE_CHECK_SHEET }: any = createTypedAction(
  `${PREFIX}SAVE_CHECK_SHEET`,
  ['checkSheetType', yup.string()],
  ['data', yup.immutable().map()],
  ['deviceId', yup.immutable().map()],

);
export const { saveCheckSheetSuccess, SAVE_CHECK_SHEET_SUCCESS }: any = createTypedAction(
  `${PREFIX}SAVE_CHECK_SHEET_SUCCESS`,
  ['deviceId', yup.immutable().map()],
  ['checkSheetType', yup.string()],
  ['data', yup.immutable().map()],
);
export const { saveCheckSheetFailed, SAVE_CHECK_SHEET_FAILED }: any = createTypedAction(
  `${PREFIX}SAVE_CHECK_SHEET_FAILED`,
  ['deviceId', yup.immutable().map()],
  ['checkSheetType', yup.string()],
);

export const { updateCheckSheet, UPDATE_CHECK_SHEET }: any = createTypedAction(
  `${PREFIX}UPDATE_CHECK_SHEET`,
  ['data', yup.immutable().map()],
  ['deviceId', yup.immutable().map()],
  ['checkSheetType', yup.string()],


);
export const { updateCheckSheetSuccess, UPDATE_CHECK_SHEET_SUCCESS }: any = createTypedAction(
  `${PREFIX}UPDATE_CHECK_SHEET_SUCCESS`,
  ['deviceId', yup.immutable().map()],
  ['data', yup.immutable().map()],
  ['checkSheetType', yup.string()],

);
export const { updateCheckSheetFailed, UPDATE_CHECK_SHEET_FAILED }: any = createTypedAction(
  `${PREFIX}UPDATE_CHECK_SHEET_FAILED`,
  ['deviceId', yup.immutable().map()],
  ['checkSheetType', yup.string()],
);

export const { fetchCheckSheets, FETCH_CHECK_SHEETS }: any = createTypedAction(
  `${PREFIX}FETCH_CHECK_SHEETS`,
  ['checkSheetType', yup.string()],

);
export const { fetchCheckSheetsSuccess, FETCH_CHECK_SHEETS_SUCCESS }: any = createTypedAction(
  `${PREFIX}FETCH_CHECK_SHEETS_SUCCESS`,
  ['checkSheetType', yup.string()],
  ['data', yup.immutable().list()],
);
export const { fetchDeviceCheckSheetsFailed, FETCH_DEVICE_CHECK_SHEETS_FAILED }: any = createTypedAction(
  `${PREFIX}FETCH_DEVICE_CHECK_SHEETS_FAILED`,
);

export const { fetchCheckSheet, FETCH_CHECK_SHEET }: any = createTypedAction(
  `${PREFIX}FETCH_CHECK_SHEET`,
  ['checkSheetId', yup.string()],
  ['checkSheetType', yup.string()],
);
export const { fetchCheckSheetSuccess, FETCH_CHECK_SHEET_SUCCESS }: any = createTypedAction(
  `${PREFIX}FETCH_CHECK_SHEET_SUCCESS`,
  ['checkSheetType', yup.string()],
  ['data', yup.immutable().map()],
  ['checkSheetId', yup.immutable().map()],
);

export const { updateCheckSheetTypeSuccess, UPDATE_CHECK_SHEET_TYPE_SUCCESS }: any = createTypedAction(
  `${PREFIX}UPDATE_CHECK_SHEET_TYPE_SUCCESS`,
  ['checkSheetType', yup.string()],
  ['checkSheetId', yup.immutable().map()],
);
export const { fetchCheckSheetFailed, FETCH_CHECK_SHEET_FAILED }: any = createTypedAction(
  `${PREFIX}FETCH_CHECK_SHEET_FAILED`,
);

export const { downloadCommissioningPdf, DOWNLOAD_COMMISSIONING_PDF }: any = createTypedAction(
  `${PREFIX}DOWNLOAD_COMMISSIONING_PDF`,
  ['reportId', yup.string()],
  ['checkSheetType', yup.string()],
  ['deviceTag', yup.string()],
);

export const { downloadCommissioningSummaryPdf, DOWNLOAD_COMMISSIONING_SUMMARY_PDF }: any = createTypedAction(
  `${PREFIX}DOWNLOAD_COMMISSIONING_SUMMARY_PDF`,
  ['params', yup.object()],
);
export const { downloadCommissioningSummaryPdfSuccess, DOWNLOAD_COMMISSIONING_SUMMARY_PDF_SUCCESS }: any = createTypedAction(
  `${PREFIX}DOWNLOAD_COMMISSIONING_SUMMARY_PDF_SUCCESS`,
);
export const { downloadCommissioningSummaryPdfFailed, DOWNLOAD_COMMISSIONING_SUMMARY_PDF_FAILED }: any = createTypedAction(
  `${PREFIX}DOWNLOAD_COMMISSIONING_SUMMARY_PDF_FAILED`,
);

export const { downloadBulkCommissioningPdf, DOWNLOAD_BULK_COMMISSIONING_PDF }: any = createTypedAction(
  `${PREFIX}DOWNLOAD_BULK_COMMISSIONING_PDF`,
  ['reportIds', yup.array()],
);
export const { downloadBulkCommissioningPdfSuccess, DOWNLOAD_BULK_COMMISSIONING_PDF_SUCCESS }: any = createTypedAction(
  `${PREFIX}DOWNLOAD_BULK_COMMISSIONING_PDF_SUCCESS`,
);
export const { downloadBulkCommissioningPdfFailed, DOWNLOAD_BULK_COMMISSIONING_PDF_FAILED }: any = createTypedAction(
  `${PREFIX}DOWNLOAD_BULK_COMMISSIONING_PDF_FAILED`,
);
export const { downloadCommissioningPdfSuccess, DOWNLOAD_COMMISSIONING_PDF_SUCCESS }: any = createTypedAction(
  `${PREFIX}DOWNLOAD_COMMISSIONING_PDF_SUCCESS`,
  ['reportId', yup.string()],
);
export const { downloadCommissioningPdfFailed, DOWNLOAD_COMMISSIONING_PDF_FAILED }: any = createTypedAction(
  `${PREFIX}DOWNLOAD_COMMISSIONING_PDF_FAILED`,
  ['reportId', yup.string()],
);

export const { openCheckSheet, OPEN_CHECK_SHEET }: any = createTypedAction(
  `${PREFIX}OPEN_CHECK_SHEET`,
  ['checkSheetType', yup.string()],
);

export const { closeCheckSheet, CLOSE_CHECK_SHEET }: any = createTypedAction(
  `${PREFIX}CLOSE_CHECK_SHEET`,
  ['checkSheetType', yup.string()],
);

export const { fetchCommissioningReports, FETCH_COMMISSIONING_REPORTS }: any = createTypedAction(
  `${PREFIX}FETCH_COMMISSIONING_REPORTS`,
  ['paginationDetails', yup.object()],
);
export const { fetchCommissioningReportsSuccess, FETCH_COMMISSIONING_REPORTS_SUCCESS }: any = createTypedAction(
  `${PREFIX}FETCH_COMMISSIONING_REPORTS_SUCCESS`,
  ['data', yup.immutable().list()],
  ['total', yup.number()],
  ['page', yup.number()],
  ['totalPages', yup.number()],
);
export const { fetchCommissioningReportsFailed, FETCH_COMMISSIONING_REPORTS_FAILED }: any = createTypedAction(
  `${PREFIX}FETCH_COMMISSIONING_REPORTS_FAILED`,
);

export const { linkDeviceToCheckSheet, LINK_DEVICE_TO_CHECK_SHEET }: any = createTypedAction(
  `${PREFIX}LINK_DEVICE_TO_CHECK_SHEET`,
  ['reportId', yup.string()],
  ['deviceId', yup.string()],
);
export const { linkDeviceToCheckSheetSuccess, LINK_DEVICE_TO_CHECK_SHEET_SUCCESS }: any = createTypedAction(
  `${PREFIX}LINK_DEVICE_TO_CHECK_SHEET_SUCCESS`,
  ['reportId', yup.string()],
  ['deviceId', yup.string()],
);
export const { linkDeviceToCheckSheetFailed, LINK_DEVICE_TO_CHECK_SHEET_FAILED }: any = createTypedAction(
  `${PREFIX}LINK_DEVICE_TO_CHECK_SHEET_FAILED`,
);


export const { fetchReportsCsvExport, FETCH_REPORTS_CSV_EXPORT }: any = createTypedAction(
  `${PREFIX}FETCH_REPORTS_CSV_EXPORT`,
  ['selectedFilters', yup.immutable().map()], // filters from top bar
  ['optionalFilters', yup.immutable().map()], // filter by component or user
);

export const { fetchReportsCsvExportSuccess, FETCH_REPORTS_CSV_EXPORT_SUCCESS }: any = createTypedAction(
  `${PREFIX}FETCH_REPORTS_CSV_EXPORT_SUCCESS`,
);

export const { fetchReportsCsvExportFailed, FETCH_REPORTS_CSV_EXPORT_FAILED }: any = createTypedAction(
  `${PREFIX}FETCH_REPORTS_CSV_EXPORT_FAILED`,
  ['err', yup.immutable().map().nullable()]
);
